import React from 'react';
import {Dropdown} from '../varios/Dropdown';

export const ViewCardCarritoCompra = (props) => {
	/* Destructuring the props object. */
	const {
		producto,
		borrarProductoCarrito,
		comienzoCuidadosDrop,
		ComienzoCuidados,
		setComienzo,
		horasSemanaDrop,
		HorasSemana,
		setHOras,
	} = props;

	return (
		<div className='cardCarritoCompra'>
			<div className='centrador imgg'>
				<div className='imagenCarritoCompra'>
					<img
						src='https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.UDyg06NfONKObSjyNBA73AHaE8%26pid%3DApi&f=1'
						style={{'border-radius': '20px'}}
					/>
				</div>
			</div>
			<div
				Id='itemInfoCarritoCompra1'
				className='itemInfoCarritoCompra'
			>
				<div className='tituloItemInfoCarritoCompra centradorLeft'>
					<div>Empresa</div>
				</div>
				<div className='bodyItemInfoCarritoCompra centradorLeft'>{producto.empresa}</div>
			</div>
			<div
				Id='itemInfoCarritoCompra2'
				className='itemInfoCarritoCompra'
			>
				<div className='tituloItemInfoCarritoCompra centradorLeft'>Servicio contratado</div>
				<div className='bodyItemInfoCarritoCompra centradorLeft'>{producto.nombre}</div>
			</div>
			<div
				Id='itemInfoCarritoCompra3'
				className='itemInfoCarritoCompra'
			>
				<div className='tituloItemInfoCarritoCompra centradorLeft'>
					Numero de referencia de la reserva
				</div>
				<div className='bodyItemInfoCarritoCompra centradorLeft'>2345243524352435</div>
			</div>
			<div
				Id='itemInfoCarritoCompra4'
				className='itemInfoCarritoCompra'
			>
				<div className='tituloItemInfoCarritoCompra centradorLeft'>Comienzo cuidados</div>
				<div className='bodyItemInfoCarritoCompra centrador'>
					<Dropdown
						Id='selectComienzoServiciosCarritoCompra'
						options={comienzoCuidadosDrop}
						values={ComienzoCuidados}
						onChange={(event) => setComienzo(event)}
						placeholder={producto.comienzoCuidados}
					/>
				</div>
			</div>
			<div
				Id='itemInfoCarritoCompra5'
				className='itemInfoCarritoCompra'
			>
				<div className='tituloItemInfoCarritoCompra centradorLeft'>Horas por semana</div>
				<div className='bodyItemInfoCarritoCompra centrador'>
					<Dropdown
						Id='selectHorasSemanaCarritoCompra'
						options={horasSemanaDrop}
						values={HorasSemana}
						onChange={(event) => setHOras(event)}
						placeholder={producto.duracion}
					/>
				</div>
			</div>
			<div className='botonBorrarCarritoCompra centradorLeft'>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='30'
					height='30'
					fill='currentColor'
					className='bi bi-trash-fill'
					viewBox='0 0 16 16'
					onClick={borrarProductoCarrito}
				>
					<path d='M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z' />
				</svg>
			</div>
		</div>
	);
};
